import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import Analytics from '../global/Analytics';
import { getUserDetails } from '../../store/selectors/user.selectors';
import { getSelectedQty, getProductDetails } from '../../store/selectors/product.selectors';
import { setSelectedQty } from '../../store/actions/product.actions';

class QuantitySelect extends Component {
  quantityOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
    .map((quantity) => ({ value: quantity, label: quantity }));

  constructor(props) {
    super(props);

    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  handleQuantityChange({ value: quantity }) {
    const {
      userDetails,
      selectedQty,
      productDetails,
      setSelectedQtyAction,
    } = this.props;

    try {
      const selectedQuantityOption = this.quantityOptions.find(({ value }) => value === selectedQty);
      let action;
      if (selectedQuantityOption.value < quantity) {
        action = 'Increased';
      } else if (selectedQuantityOption.value > quantity) {
        action = 'Decreased';
      } else {
        action = 'Same';
      }
      const {
        email = '',
      } = userDetails;
      Analytics.enqueue({
        method: 'PDPAction',
        params: {
          event: 'Product Quantity',
          item: productDetails,
          action,
          email,
          quantity,
        },
        location: Analytics.getLocation(),
      });
    } catch (e) { /* nothing to do */ }
    setSelectedQtyAction(quantity);
  }

  render() {
    const {
      selectedQty,
      label,
    } = this.props;
    const selectedQuantityOption = this.quantityOptions.find(({ value }) => value === selectedQty);
    return (
      <Select
        aria-label={label}
        className="pdp-add-select"
        classNamePrefix="pdp-add-select"
        value={selectedQuantityOption}
        onChange={this.handleQuantityChange}
        options={this.quantityOptions}
        isSearchable={false}
        backspaceRemovesValue={false}
        autoFocus={false}
        instanceId="quantity-select"
      />
    );
  }
}

const mapStateToProps = (state) => ({
  userDetails: getUserDetails(state),
  selectedQty: getSelectedQty(state),
  productDetails: getProductDetails(state),
});

const mapDispatchToProps = {
  setSelectedQtyAction: setSelectedQty,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuantitySelect);
